import { Activable } from "./activable";
import Table from './table'

export class Verification extends Activable {
    coll_ref: string = Table.Verification
    verifiedBy: string
    documents: string[]
}
